import React, { FC, useContext, useEffect } from 'react';
import { Context } from "../../index";
import { useNavigate } from "react-router-dom";
import '../../pages/Main/MainPage.css'

const Reference: FC = (index) => {
    const { store } = useContext(Context);
    const navigate = useNavigate();


    // useEffect(() => {
    //     if (!store.isAuth) {
    //         navigate("/login");
    //     }
    // }, [store.isAuth, navigate]);

    if (store.isAuth) {
        return (
            <div>В разработке...</div>
        );
    } else {
        return (
            <div className="main__page">
                <h1>Авторизуйтесь</h1>
            </div>
        );
    }
}

export default Reference;